module.exports = __webpack_public_path__ + "img/流体力学3_2_2.f8c8388c.jpg";